import { type MobileHamburgerNavItem } from '~/interfaces/HeaderFooterNavV2';

import styles from './HeaderMobile.module.css';

export const HeaderMobile = ({
  mobileNavData


}: {mobileNavData: MobileHamburgerNavItem[];}) => {
  console.log(mobileNavData);

  return (
    <header className={styles.headerContainer} data-testid="header-mobile-v2">
			<h1>Mobile Header V2</h1>
		</header>);

};